// extracted by mini-css-extract-plugin
module.exports = {"StyledHomeGarage":"StyledHomeGarage_StyledHomeGarage__yJ8gZ","category_page_vehicle_selector":"StyledHomeGarage_category_page_vehicle_selector__MBTwL"};